<template>

  <div class="slot-availability-planner">

    <mdb-container class="mt-2">

      <mdb-row>
        <mdb-col col="md-12">

          <jumbotron :isAvailable="isAvailable"
                     :showAvailabilityIcon="true"
                     :subtitle="subtitle"
                     :title="title"></jumbotron>

        </mdb-col>
      </mdb-row>

    </mdb-container>

    <active-selections :isAvailable="isAvailable" :showAll="true"/>

    <mdb-container>

      <mdb-row>

        <mdb-col v-if="isAvailable" col="md-12">


          <div class="price-box" v-if="!settings.hide_price">
            <span class="h5">{{ $t('slotAvailability.currentPrice') }}</span>
            <div class="price-box-amount">
              <span class="price-box-amount--text">{{ calculatedPrice }}</span>
              <span class="price-box-amount--vat">{{ $t('slotAvailability.vatInfo') }}</span>
            </div>
          </div>

          <mdb-alert class="alert alert-warning mt-3" v-if="saveError">
            {{ saveError }}
          </mdb-alert>

          <mdb-btn block class="large-button btn-primary mt-3" @click="reserve">
            {{ $t('general.reserveNow') }}
          </mdb-btn>

          <mdb-btn block class="large-button btn-secondary mt-3" @click="$router.push({name: 'Inventory'})">
            {{ $t('general.moreInfo') }}
          </mdb-btn>

          <mdb-col col="md-12 mt-3 " v-if="!settings.hide_price">
            <p class="price-info">{{ $t('slotAvailability.priceInfo') }}</p>
          </mdb-col>


        </mdb-col>


        <mdb-col v-else col="md-12">


          <mdb-btn block class="large-button btn-primary mt-3" @click="$router.push({name: 'ScheduleDuration'})">
            {{ $t('slotAvailability.changeAppointment') }}
          </mdb-btn>

          <mdb-btn block class="large-button btn-secondary mt-3" @click="$router.push({name: 'MoreDateAvailability'})">
            {{ $t('slotAvailability.showAvailability') }}
          </mdb-btn>

          <div class="contact-info mt-3">
            <p class="title">{{ $t('slotAvailability.unavailableInfo') }}</p>
            <p class="text" v-html="$t('slotAvailability.unavailableInfoText', {phoneNumber: ''})"></p>
          </div>

        </mdb-col>


      </mdb-row>


    </mdb-container>

  </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {

  name: "SlotAvailability",

  data() {
    return {
      dateTimeFormat: 'YYYY-MM-DD hh:mm A',
      calculatedPrice: "0,00EUR",
      isAvailable: false,
      saveError: null
    }
  },

  metaInfo() {

    return {
      title: this.title
    }

  },

  mounted() {
    this.getResourceAvailability();
  },

  computed: {
    ...mapGetters({configurator: "getConfigurator", settings: "getSettings"}),

    moment() {
      return moment;
    },

    title() {
      return this.isAvailable ? this.$t('slotAvailability.availableTitle') : this.$t('slotAvailability.notAvailableTitle')
    },

    subtitle() {
      return this.isAvailable ? this.$t('slotAvailability.availableSubtitle') : this.$t('slotAvailability.notAvailableSubtitle')
    }

  },

  methods: {
    ...mapActions(["updateResource", "saveConfiguratorToServer"]),

    reserve() {
      // instead of saving the data directly go to the checkout page
      this.$router.push({name: 'Checkout'});

    },
    getResourceAvailability() {
      // prepare params
      let params = {
        date_from: this.configurator.duration.date_from,
        date_to: this.configurator.duration.date_to,
        time_from: this.configurator.duration.time_from,
        time_to: this.configurator.duration.time_to,
        // duration: '00:30',
        free_text_field_ids_str: `${this.configurator.eventType.freeTextFieldId},${this.configurator.seatType.freeTextFieldId},${this.configurator.persons.id}`,
        free_text_field_conditions_str: 'et,et,great_than_et',
        free_text_field_values_str: `${encodeURIComponent(this.configurator.eventType.title)},${encodeURIComponent(this.configurator.seatType.title)},${this.configurator.persons.count}`
      }

      if (RESOURCES) {
        params = {...params, resource_id: RESOURCES}
      }

      this.$store.dispatch("updateIsLoading", true)

      this.$http.getResourceAvailability(params)
          .then(({data}) => {
            if (data.success) {
              if (data.data.resource_id) {
                this.isAvailable = true;
                this.$http.getResource(data.data.resource_id)
                    .then(({data}) => {
                      if (data.success) {
                        this.updateResource(data.data);

                        this.$http.calculatePrice({...params, resource_id: data.data.id})
                            .then(({data}) => {
                              if (data.success) {
                                this.calculatedPrice = data.data.price;
                              }
                            })

                      }
                    });
              }
            }
          })
          .finally(() => this.$store.dispatch("updateIsLoading", false))

    }
  }
}
</script>

<style lang="scss" scoped>
@import "_index.scss";
</style>


// WEBPACK FOOTER //
// src/components/pages/slot-availability/index.vue